import { RENEW_FORM_MESSAGES, RenewFormMessages } from "./renew-form.messages";
import { RENEW_PRODUCT_MESSAGES, RenewProductMessages } from "./renew-product.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type RenewMessages = ActionButtonMessages &
  SidebarMessages &
  RenewFormMessages &
  RenewProductMessages & {
    // Titles and Labels
    title: string;
    personalDataSectionTitle: string;
    paymentDataSectionTitle: string;

    // Error messages
    salesProductNotFoundError: string;
    salesProductNotFoundDescription: string;
    salesProductNotFoundAlt: string;
    salesProductErrorToLoad: string;
  };

export const RENEW_MESSAGES: RenewMessages = {
  // Titles and Labels
  title: "Renovação",
  personalDataSectionTitle: "Os Seus Dados",
  paymentDataSectionTitle: "Informações de Pagamento",

  // Error messages
  salesProductNotFoundError: "Produto não encontrado.",
  salesProductNotFoundDescription: "Não conseguimos encontrar o produto que você está procurando",
  salesProductNotFoundAlt: "Produto não encontrado.",
  salesProductErrorToLoad: "Erro ao carregar o produto de venda. Tente novamente mais tarde.",

  ...RENEW_FORM_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...SIDEBAR_MESSAGES,
  ...RENEW_PRODUCT_MESSAGES,
};
